import React, { useState } from 'react';
import * as S from './TableComponent.style';
import { TableBody, Tooltip } from '@mui/material';
import { useScreenSize } from 'utils/helpers';

type TDetailsRows = {
  campo: string | null;
  link: boolean;
  onClick: () => void;
};

export type TTableDetails = {
  rowCell: TDetailsRows[];
};

type TTableProps = {
  data: TTableDetails[];
  table: string[];
  selectedFilterColumns?: string[];
};

const TableComponente: React.FC<TTableProps> = ({ data, table }) => {
  const [hiddenColumns, setHiddenColumns] = useState<boolean[]>(Array(table.length).fill(false));

  const toggleColumnVisibility = (index: number) => {
    setHiddenColumns((prevHiddenColumns) => {
      const newHiddenColumns = [...prevHiddenColumns];
      newHiddenColumns[index] = !newHiddenColumns[index];
      return newHiddenColumns;
    });
  };

  const isMobileNavigation = (): boolean => {
    const userAgent = navigator.userAgent;
    const mobileKeywords = ['Mobi', 'Android', 'iPhone', 'iPad', 'Windows Phone'];
    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  };

  const isBreak = isMobileNavigation() ? true : useScreenSize(780);

  return (
    <>
      {!isBreak ? (
        <div style={{ overflowX: 'scroll', overflowY: 'hidden', whiteSpace: 'nowrap' }}>
          <S.TTable aria-label="simple table">
            <S.THTableHead>
              <S.THTableRow>
                {table.map((item, index) => (
                  <S.THTableCell
                    align="center"
                    key={index}
                    className={hiddenColumns[index] ? 'hidden-column' : 'visible-column'}
                  >
                    <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between' }}>
                      <span style={{ display: hiddenColumns[index] ? 'none' : 'inline' }}>{item}</span>
                      <Tooltip title={item} placement="top">
                        <button
                          style={{
                            cursor: 'pointer',
                            border: 'none',
                            backgroundColor: 'transparent',
                            marginLeft: '15px',
                          }}
                          onClick={() => toggleColumnVisibility(index)}
                        >
                          <svg
                            fill="#136033"
                            width="15px"
                            height="15px"
                            viewBox="0 0 56 56"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke="#000000"
                              strokeWidth="2"
                              d="M 4.9140 28.0000 C 4.9140 28.5860 5.1484 29.1250 5.6171 29.5703 L 19.2811 42.9766 C 19.6796 43.3750 20.2889 43.6094 20.7811 43.6094 C 22.0233 43.6094 22.8671 42.7656 22.8671 41.5469 C 22.8671 40.9375 22.6562 40.4922 22.2811 40.1172 L 15.6718 33.6484 L 11.2889 29.8750 L 16.7264 30.1094 L 39.2968 30.1094 L 44.7343 29.8750 L 40.3515 33.6484 L 33.7186 40.1172 C 33.3436 40.4922 33.1562 40.9375 33.1562 41.5469 C 33.1562 42.7656 33.9764 43.6094 35.2186 43.6094 C 35.7343 43.6094 36.3436 43.3750 36.7421 42.9766 L 50.4064 29.5703 C 50.8748 29.1250 51.0860 28.5860 51.0860 28.0000 C 51.0860 27.4375 50.8748 26.8984 50.4064 26.4297 L 36.7421 13.0469 C 36.3436 12.6484 35.7343 12.3906 35.2186 12.3906 C 33.9764 12.3906 33.1562 13.2578 33.1562 14.4766 C 33.1562 15.0625 33.3436 15.5313 33.7186 15.9062 L 40.3515 22.3516 L 44.7343 26.1484 L 39.2968 25.9141 L 16.7264 25.9141 L 11.2889 26.1484 L 15.6718 22.3516 L 22.3046 15.9062 C 22.6562 15.5313 22.8671 15.0625 22.8671 14.4766 C 22.8671 13.2578 22.0233 12.3906 20.7811 12.3906 C 20.2889 12.3906 19.6796 12.6484 19.2811 13.0469 L 5.6171 26.4297 C 5.1484 26.8984 4.9140 27.4375 4.9140 28.0000 Z"
                            />
                          </svg>
                        </button>
                      </Tooltip>
                    </div>
                  </S.THTableCell>
                ))}
              </S.THTableRow>
            </S.THTableHead>

            <TableBody>
              {data &&
                data.map((row, rowIndex) => (
                  <S.TTableRow key={rowIndex}>
                    {row.rowCell.map((cell, colIndex) => (
                      <S.TTableCell
                        link={cell.link}
                        key={colIndex}
                        align="center"
                        component="th"
                        scope="row"
                        className={hiddenColumns[colIndex] ? 'hidden-column' : 'visible-column'}
                        onClick={
                          cell.onClick ? cell.onClick : () => console.log(`Cell ${rowIndex}-${colIndex} clicked`)
                        }
                      >
                        <span style={{ display: hiddenColumns[colIndex] ? 'none' : 'inline' }}>{cell.campo}</span>
                      </S.TTableCell>
                    ))}
                  </S.TTableRow>
                ))}
            </TableBody>
          </S.TTable>
        </div>
      ) : (
        <S.ContainerMobile>
          {data.map((row, index) => (
            <S.ContainerWrapperMobile key={index}>
              <S.ContainerTiTle>
                {table.map((item, i) => (
                  <S.ItemTitle key={i}>
                    <span>{item}</span>
                  </S.ItemTitle>
                ))}
              </S.ContainerTiTle>
              <S.ContainerRow>
                {row.rowCell.map((cell, i) => (
                  <S.ItemRow
                    key={i + cell.campo}
                    link={cell.link}
                    onClick={cell.onClick}
                    style={{
                      verticalAlign: 'middle',
                    }}
                  >
                    <span>{cell.campo}</span>
                  </S.ItemRow>
                ))}
              </S.ContainerRow>
            </S.ContainerWrapperMobile>
          ))}
        </S.ContainerMobile>
      )}
    </>
  );
};

export default TableComponente;
